<template>
	<div class="enter_info_box animate__animated animate__fadeIn">
		<div class="enter_info">
			<div class="search_box">
				<div class="box_line">
					<div class="search-btn upload_green" @click="fnOpenAddWin" v-if="!tableData.length"><span>添加企业信息</span></div>
					<div class="search-btn upload_green" @click="fnUploadProjectToGZS"><span>上传至贵州省人社厅</span></div>
				</div>
			</div>
			<div class="cont_list">
				<div class="list_title">
					<div class="title_item">企业事业单位名称</div>
					<div class="title_item">统一社会信用代码</div>
					<div class="title_item">法定代表人姓名</div>
					<div class="title_item">单位类型</div>
					<div class="title_item">注册地址</div>
					<div class="title_item">办公地址(营业地址)</div>
					<div class="title_item">注册日期</div>
					<div class="title_item">上传状态</div>
					<div class="title_item">操作</div>
				</div>
				<div class="list_boxes">
					<div class="list_box">
						<div v-if="tableData">
							<div class="box_line" v-for="(item, index) in tableData" :key="index">
								<div class="list_item">{{ item.orgName }}</div>
								<div class="list_item">{{ item.orgCreditCode }}</div>
								<div class="list_item">{{ item.legalPersonName }}</div>
								<div class="list_item">{{ item.orgType }}</div>
								<div class="list_item">{{ item.registerAddress }}</div>
								<div class="list_item">{{ item.officeAddress }}</div>
								<div class="list_item">{{ item.registDate }}</div>
								<div class="list_item" :title="item.upload_at ? '已上传—' + item.upload_at : '未上传'"><span>{{ item.upload_at ? '已上传—' + item.upload_at : '未上传' }}</span></div>
								<div class="list_item">
									<div>
										<div class="search_btn" v-if="!item.upload_at" @click="fnOpenEditWin(item, false)"><span>编辑</span></div>
										<div class="search_btn" v-else @click="fnOpenEditWin(item, true)"><span>详情</span></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 添加、编辑参建单位弹窗 -->
		</div>
		<div class="dialog_enterinfo" v-if="showUnit">
			<el-dialog title="编辑企业信息" top="20vh" :custom-class="'animate__animated animate__fadeIn'" :modal="false" :visible.sync="showUnit" center>
				<div class="enterinfo_list">
					<div class="enterinfo_box">
						<div class="box_list">

							<div class="left-item item">
								<div class="row-one">
									<div class="row-item">
										参数说明
										<span style="color:#F56C6C;">（* 必填）</span>
									</div>
									<div class="row-item">参数值</div>
								</div>
								<div class="row">
									<div class="row-item">*企业事业单位名称</div>
									<div class="row-item"><el-input v-model="formData.orgName"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">*统一社会信用代码</div>
									<div class="row-item"><el-input v-model="formData.orgCreditCode"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">工商注册号</div>
									<div class="row-item"><el-input v-model="formData.orgLicenseRegistCode"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">*法定代表人姓名</div>
									<div class="row-item"><el-input v-model="formData.legalPersonName"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">*法定代表人证件号码</div>
									<div class="row-item"><el-input v-model="formData.legalPersonIdCard"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">*法定代表人电话</div>
									<div class="row-item"><el-input v-model="formData.legalPersonPhone"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">法定代表人职务</div>
									<div class="row-item"><el-input v-model="formData.legalPersonDuty"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">法定代表人职称</div>
									<div class="row-item"><el-input v-model="formData.legalPersonProTitle"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">*单位类型</div>
									<div class="row-item">
										<el-select size="small" v-model="formData.orgType" filterable placeholder="请选择" style="border-radius: 0;">
											<el-option label="请选择" value=""></el-option>
											<el-option v-for="item in GZS.orgType" :key="item" :label="item" :value="item"></el-option>
										</el-select>
									</div>
								</div>
								<div class="row">
									<div class="row-item">经济类型</div>
									<div class="row-item">
										<el-select size="small" v-model="formData.economyType" filterable placeholder="请选择" style="border-radius: 0;">
											<el-option label="请选择" value=""></el-option>
											<el-option v-for="item in GZS.economyType" :key="item" :label="item" :value="item"></el-option>
										</el-select>
									</div>
								</div>
								<div class="row">
									<div class="row-item">隶属关系</div>
									<div class="row-item">
										<el-select size="small" v-model="formData.affiliation" filterable placeholder="请选择" style="border-radius: 0;">
											<el-option label="请选择" value=""></el-option>
											<el-option v-for="item in GZS.affiliation" :key="item" :label="item" :value="item"></el-option>
										</el-select>
									</div>
								</div>
								<div class="row">
									<div class="row-item">经营方式</div>
									<div class="row-item">
										<el-select size="small" v-model="formData.operateType" filterable placeholder="请选择" style="border-radius: 0;">
											<el-option label="请选择" value=""></el-option>
											<el-option v-for="item in GZS.operateType" :key="item" :label="item" :value="item"></el-option>
										</el-select>
									</div>
								</div>
								<div class="row">
									<div class="row-item">*注册资本（元）</div>
									<div class="row-item"><el-input v-model="formData.registerCapital"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">*实收资本（元）</div>
									<div class="row-item"><el-input v-model="formData.paidinCapital"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">资本币种</div>
									<div class="row-item">
										<el-select size="small" v-model="formData.capitalCurrency" filterable placeholder="请选择" style="border-radius: 0;">
											<el-option label="请选择" value=""></el-option>
											<el-option v-for="item in GZS.capitalCurrency" :key="item" :label="item" :value="item"></el-option>
										</el-select>
									</div>
								</div>
								<div class="row">
									<div class="row-item">*成立日期</div>
									<div class="row-item">
										<el-date-picker v-model="formData.registerDate" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间"></el-date-picker>
									</div>
								</div>
								<div class="row">
									<div class="row-item">
										*注册地行政区划代码
										<a href="http://www.mca.gov.cn/article/sj/xzqh/1980/201803/201803131454.html" style="font-size: 12px;color: blue" target="_blank">（查看所在区域编码）</a>
									</div>
									<div class="row-item"><el-input v-model="formData.registerAddressCode" placeholder="12位位行政区划码,如520115000000(以0补足12位)"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">*邮政编码</div>
									<div class="row-item"><el-input v-model="formData.postalCode"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">登记注册类型</div>
									<div class="row-item">
										<el-select size="small" v-model="formData.registerType" filterable placeholder="请选择" style="border-radius: 0;">
											<el-option label="请选择" value=""></el-option>
											<el-option v-for="item in GZS.registerType" :key="item" :label="item" :value="item"></el-option>
										</el-select>
									</div>
								</div>
							</div>

							<div class="right-item item">
								<div class="row-one">
									<div class="row-item">
										参数说明
										<span style="color:#F56C6C;">（* 必填）</span>
									</div>
									<div class="row-item">参数值</div>
								</div>
								<div class="row">
									<div class="row-item">*注册地址</div>
									<div class="row-item"><el-input v-model="formData.registerAddress" placeholder="1-200位中英文可见字符"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">*劳资负责人姓名</div>
									<div class="row-item"><el-input v-model="formData.laborerPersonName"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">*劳资负责人公民身份证号码</div>
									<div class="row-item"><el-input v-model="formData.laborerPersonIdCard"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">*劳资负责人联系电话</div>
									<div class="row-item"><el-input v-model="formData.laborerPersonPhone"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">所属行业</div>
									<div class="row-item">
										<el-select size="small" v-model="formData.industry" filterable placeholder="请选择" style="border-radius: 0;">
											<el-option label="请选择" value=""></el-option>
											<el-option v-for="item in GZS.industry" :key="item" :label="item" :value="item"></el-option>
										</el-select>
									</div>
								</div>
								<div class="row">
									<div class="row-item">*联系人姓名</div>
									<div class="row-item"><el-input v-model="formData.contactPerson"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">*联系人电话</div>
									<div class="row-item"><el-input v-model="formData.contactPersonPhone"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">传真号码</div>
									<div class="row-item"><el-input v-model="formData.faxNumber"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">办公号码</div>
									<div class="row-item"><el-input v-model="formData.officeNumber"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">*办公地址(营业地址)</div>
									<div class="row-item"><el-input v-model="formData.officeAddress"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">*注册日期</div>
									<div class="row-item">
										<el-date-picker v-model="formData.registDate" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间"></el-date-picker>
									</div>
								</div>
								<div class="row">
									<div class="row-item">企业网址</div>
									<div class="row-item"><el-input v-model="formData.webSite"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">企业邮箱</div>
									<div class="row-item"><el-input v-model="formData.email"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">银行名称</div>
									<div class="row-item">
										<el-select size="small" v-model="formData.bankName" filterable placeholder="请选择" style="border-radius: 0;">
											<el-option label="请选择" value=""></el-option>
											<el-option v-for="item in GZS.bankName" :key="item" :label="item" :value="item"></el-option>
										</el-select>
									</div>
								</div>
								<div class="row">
									<div class="row-item">银行卡号</div>
									<div class="row-item"><el-input v-model="formData.bankAccount"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">银行支行名称</div>
									<div class="row-item"><el-input v-model="formData.bankBranchName"></el-input></div>
								</div>
								<div class="row">
									<div class="row-item">银行联号</div>
									<div class="row-item"><el-input v-model="formData.bankAffiliated"></el-input></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<div class="btn_line">
						<div class="search-btn red" @click="showUnit = false"><span>关 闭</span></div>
						<div class="search-btn" @click="fnAddOrEdit"><span>保 存</span></div>
					</div>
				</div>
			</el-dialog>
		</div>
	</div>
</template>
<script>
import { fnRequestPlatform } from '@/utils/upload';
import APP from '@/utils/base';
import request from '@/utils/request';
import GZS from '@/configure/gzs';

export default {
	data() {
		return {
			isShowDetails: false, // 查看详情
			showUnit: false, // 添加、编辑参建单位弹窗
			tableData: [], // 列表数据
			GZS: GZS,
			editId: '', // 编辑id
			formData: {
				orgName: '', // 企业事业单位名称
				orgCreditCode: '', // 统一社会信用代码
				legalPersonName: '', // 法定代表人姓名
				legalPersonIdCard: '', // 法定代表人证件号码
				legalPersonPhone: '', // 法定代表人电话
				orgType: '', // 单位类型
				registerCapital: '', // 注册资本（元）
				registerAddressCode: '', // 注册地行政区划代码
				postalCode: '', // 邮政编码
				registerAddress: '', // 注册地址
				laborerPersonName: '', // 劳资负责人姓名
				laborerPersonIdCard: '', // 劳资负责人公民身份证号码
				laborerPersonPhone: '', // 劳资负责人联系电话
				contactPerson: '', // 联系人姓名
				contactPersonPhone: '', // 联系人电话
				officeAddress: '', // 办公地址(营业地址)
				registDate: '', // 注册日期
				orgLicenseRegistCode: '', // 工商注册号
				legalPersonDuty: '', // 法定代表人职务
				legalPersonProTitle: '', // 法定代表人职称
				economyType: '', // 经济类型
				affiliation: '', // 隶属关系
				operateType: '', // 经营方式
				paidinCapital: '', // 实收资本（元）
				capitalCurrency: '', // 资本币种
				registerDate: '', // 成立日期
				registerType: '', // 登记注册类型
				industry: '', // 所属行业
				faxNumber: '', // 传真号码
				officeNumber: '', // 办公号码
				webSite: '', // 企业网址
				email: '', // 企业邮箱
				bankName: '', // 银行名称
				bankAccount: '', // 银行卡号
				bankBranchName: '', // 银行支行名称
				bankAffiliated: '' // 银行联号
			}
		};
	},
	created() {
		this.fnInit();
	},
	methods: {
		// 初始化函数
		fnInit() {
			this.fnGetAllUnit();
		},
		// 获取项目下所有企业信息
		fnGetAllUnit() {
			request({
				url: 'project_gzs/getUnit',
				method: 'GET',
				params: {
					type: 1
				}
			})
				.then(res => {
					this.tableData = res.data;
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 打开添加参建单位弹窗
		fnOpenAddWin() {
			for (let _key in this.formData) {
				this.formData[_key] = null;
			}
			this.formData.type = 1;
			this.showUnit = true;
		},
		// 打开 编辑/ 查看详情 参建单位弹窗
		fnOpenEditWin(_data, _istrue) {
			this.isShowDetails = _istrue; // 编辑为false  详情为true
			for (let _key in this.formData) {
				this.formData[_key] = _data[_key];
			}
			this.editId = _data['id'];
			this.formData.type = 1;
			this.showUnit = true;
		},
		// 添加、编辑参建单位
		fnAddOrEdit() {
			let _needField = {
				orgName: '企业事业单位名称',
				orgCreditCode: '统一社会信用代码',
				legalPersonName: '法定代表人姓名',
				legalPersonIdCard: '法定代表人证件号码',
				legalPersonPhone: '法定代表人电话',
				orgType: '单位类型',
				registerCapital: '注册资本（元）',
				registerAddressCode: '注册地行政区划代码',
				postalCode: '邮政编码',
				registerAddress: '注册地址',
				laborerPersonName: '劳资负责人姓名',
				laborerPersonIdCard: '劳资负责人公民身份证号码',
				laborerPersonPhone: '劳资负责人联系电话',
				contactPerson: '联系人姓名',
				contactPersonPhone: '联系人电话',
				officeAddress: '办公地址(营业地址)',
				registDate: '注册日期'
			};
			for (let _key in _needField) {
				if (this.formData[_key] == '' || this.formData[_key] == null) {
					this.$message.warning(_needField[_key] + '不能为空');
					return;
				}
			}
			if (this.formData.orgName.length > 100) {
				this.$message.warning('企业事业单位名称应为1-100位中英文可见字符');
				return;
			}
			if (this.formData.orgCreditCode.length !== 18) {
				this.$message.warning('统一社会信用代码长度应为18位');
				return;
			}
			if (this.formData.legalPersonIdCard.length !== 18) {
				this.$message.warning('法定代表人证件号码长度应为18位');
				return;
			}
			const reg = /^1[3-9]\d{9}$/;
			if (!reg.test(this.formData.legalPersonPhone)) {
				this.$message.warning('请输入正确的法定代表人电话');
				return;
			}
			if (this.formData.registerAddressCode.length !== 12) {
				this.$message.warning('注册地行政区划代码应为12位,不足则以0补足12位');
				return;
			}
			if (this.formData.postalCode.length < 6 || this.formData.postalCode.length > 12) {
				this.$message.warning('邮政编码应为6-12位正整数字符(无符号)');
				return;
			}
			if (this.formData.laborerPersonIdCard.length !== 18) {
				this.$message.warning('劳资负责人公民身份证号码长度应为18位');
				return;
			}
			if (!reg.test(this.formData.laborerPersonPhone)) {
				this.$message.warning('请输入正确的劳资负责人电话');
				return;
			}
			if (!reg.test(this.formData.contactPersonPhone)) {
				this.$message.warning('请输入正确的联系人电话');
				return;
			}
			let _data = this.formData;
			if (this.editId) {
				_data.id = this.editId;
			}
			request({
				url: 'project_gzs/addOrEditUnit',
				method: 'POST',
				data: _data
			})
				.then(res => {
					this.$message.success(res.data);
					this.showUnit = false;
					this.fnInit();
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 上传项目信息至贵州省人社厅
		fnUploadProjectToGZS() {
			console.log('aaa');
			fnRequestPlatform(
				{
					url: '/Gzs/uploadOrgInfo',
					method: 'GET'
				},
				res => {
					if (res.code == APP.HTTP_STATUS.SUCCESS) {
						this.$message.success(res.data);
						this.fnInit();
					} else {
						this.$message.error(res.data);
					}
				}
			);
		}
	}
};
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.enter_info_box {
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;
	.enter_info {
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.search_box {
	height: 32px;
	width: 1880px;
	margin-top: 24px;
	margin-left: 20px;
	@include flex-box(space-between, center, column);
	.box_line {
		width: 1880px;
		height: 32px;
		@include flex-box(flex-start, center);
		.line_input {
			min-width: 280px;
			height: 30px;
			margin-right: 10px;
			border-top-right-radius: 1px;
			border-bottom-right-radius: 1px;
			background-color: rgba(49, 88, 128, 0.4);
			@include flex-box(flex-start, center);
			.input_title {
				width: 69px;
				height: 30px;
				font-size: 14px;
				color: #9bf9fc;
				border-radius: 2px;
				background-color: rgba(155, 249, 252, 0.1);
				@include flex-box(center, center);
			}
		}
	}
}
.cont_list {
	margin-top: 29px;
	margin-left: 28px;
	width: 1864px;
	height: 773px;
	border-radius: 10px;
	background-color: rgba(29, 68, 149, 0.1);
	.list_title {
		width: 1864px;
		height: 48px;
		background: url(../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start, center);
		.title_item {
			height: 48px;
			@include flex-box(center, center);
			&:nth-child(1) {
				width: 213px;
				margin-right: 2px;
				margin-left: 40px;
			}
			&:nth-child(2) {
				width: 191px;
				margin: 0 2px;
			}
			&:nth-child(3) {
				width: 141px;
				margin: 0 2px;
			}
			&:nth-child(4) {
				width: 131px;
				margin: 0 2px;
			}
			&:nth-child(5) {
				width: 300px;
				margin: 0 2px;
			}
			&:nth-child(6) {
				width: 300px;
				margin: 0 2px;
			}
			&:nth-child(7) {
				width: 171px;
				margin: 0 2px;
			}
			&:nth-child(8) {
				width: 191px;
				margin: 0 2px;
			}
			&:nth-child(9) {
				width: 114px;
				margin-left: 2px;
				margin-right: 40px;
			}
		}
	}
	.list_boxes {
		width: 1864px;
		height: 725px;
		position: relative;
		overflow: hidden;
		.list_box {
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
			.box_line {
				width: 1784px;
				height: 70px;
				margin: 7px 0 0 40px;
				font-size: 16px;
				color: #ffffff;
				border-bottom: 1px dashed #1d4495;
				@include flex-box(flex-start, center);
				&:hover{
					background-color: rgba(49, 88, 128, 0.4);
				}
				.list_item {
					height: 70px;
					text-align: center;
					@include flex-box(center, center);
					&:nth-child(1) {
						width: 213px;
						margin-right: 2px;
					}
					&:nth-child(2) {
						width: 191px;
						margin: 0 2px;
					}
					&:nth-child(3) {
						width: 141px;
						margin: 0 2px;
					}
					&:nth-child(4) {
						width: 131px;
						margin: 0 2px;
					}
					&:nth-child(5) {
						width: 300px;
						margin: 0 2px;
					}
					&:nth-child(6) {
						width: 300px;
						margin: 0 2px;
					}
					&:nth-child(7) {
						width: 171px;
						margin: 0 2px;
					}
					&:nth-child(8) {
						width: 191px;
						margin: 0 2px;
					}
					&:nth-child(9) {
						width: 114px;
						margin-left: 2px;
					}
					div {
						@include flex-box(center, center);
					}
					span {
						width: 100%;
						cursor: pointer;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
			}
		}
	}
}

.dialog_enterinfo{
	.btn_line {
		@include flex-box(center, center);
	}
	>>> .el-dialog {
		width: 1300px;
		height: 700px;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(58, 116, 221, 1);
	}
	>>> .el-form-item__label {
		color: #4db4f4;
	}
	>>> .el-dialog__title {
		color: #4db4f4;
	}
	>>> .el-dialog__close {
		color: #4db4f4;
	}
	.enterinfo_list{
		width: 1250px;
		height: 525px;
		position: relative;
		overflow: hidden;
		.enterinfo_box{
			position: absolute;
			left: 0;
			right: -20px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
			.box_list{
				width: 1250px;
				@include flex-box();
				color: rgba(255,255,255,0.8);
				.item{
					width: 620px;
					margin-right: 10px;
					.row-one{
						width: 620px;
						height: 45px;
						line-height: 45px;
						background: url(../../../assets/img/per_list_bg.png) no-repeat;
						background-size: 100% 100%;
						@include flex-box(space-between,center);
						.row-item{
							width: 310px;
							height: 45px;
							line-height: 45px;
							text-align: center;
							&:nth-child(1){
								width: 270px;
								margin-right: 10px;
								margin-left: 30px;
							}
							&:nth-child(2){
								width: 280px;
								margin-right: 30px;
							}
						}
					}
					.row{
						width: 560px;
						margin-left: 30px;
						height: 45px;
						line-height: 45px;
						border-bottom: 1px dashed #1D4495;
						@include flex-box(space-between,center);
						.row-item{
							height: 45px;
							line-height: 45px;
							&:nth-child(1){
								width: 230px;
								margin-right: 10px;
							}
							&:nth-child(2){
								width: 320px;
							}
							>>> .el-input__inner {
								width: 300px;
								height: 30px;
								border-radius: 2px;
								border: none;
								background-color: rgba(77, 180, 244, 0.2);
								color: rgba(77, 180, 244, 0.9);
								&::-webkit-input-placeholder {
									color: rgba(77, 180, 244, 0.7);
								}
								&::-moz-placeholder {
									/* Mozilla Firefox 19+ */
									color: rgba(77, 180, 244, 0.7);
								}
								&:-moz-placeholder {
									/* Mozilla Firefox 4 to 18 */
									color: rgba(77, 180, 244, 0.7);
								}
								&:-ms-input-placeholder {
									/* Internet Explorer 10-11 */
									color: rgba(77, 180, 244, 0.7);
								}
							}
							>>>.el-select__caret {
								color: rgba(77, 180, 244, 0.7);
							}
							>>> .el-select-dropdown {
								background-color: rgba(77, 180, 244, 0.2);
								border: 1px solid rgba(77, 180, 244, 1);
							}
							>>> .popper__arrow {
								border-bottom-color: rgba(77, 180, 244, 1) !important;
							}
							>>> .el-select-dropdown__item {
								color: rgba(77, 180, 244, 0.7);
							}
							>>> .el-select-dropdown__item:hover {
								color: #409eff;
							}
							>>> .el-select-dropdown__item.hover {
								color: #409eff;
							}
							>>> .el-input__icon {
								color: rgba(77, 180, 244, 0.7);
							}
							>>> .el-range-input {
								background: transparent;
								&::-webkit-input-placeholder {
									color: rgba(77, 180, 244, 0.7);
								}
								&::-moz-placeholder {
									/* Mozilla Firefox 19+ */
									color: rgba(77, 180, 244, 0.7);
								}
								&:-moz-placeholder {
									/* Mozilla Firefox 4 to 18 */
									color: rgba(77, 180, 244, 0.7);
								}
								&:-ms-input-placeholder {
									/* Internet Explorer 10-11 */
									color: rgba(77, 180, 244, 0.7);
								}
							}
							>>> .el-range-separator {
								color: rgba(77, 180, 244, 0.7);
							}
						}
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/views/EnterInfo/EnterInfoGzs/index.vue